import * as React from "react";
import {
  ResponsiveContainer,
  Tooltip,
  BarChart,
  Brush,
  CartesianGrid,
  Bar,
  XAxis,
  YAxis,
} from "recharts";
import { CustomTooltip } from "../CustomTooltip/CustomTooltip";
import { IMetricsContent } from "./ChartDays";
import {
  IMissingCity,
  IMissingCountry,
} from "src/modules/Dashboard/Home/types";
import useColorsChartBars from "src/share/hooks/useChartBarsColors";

export interface IChartBarsMetrics {
  type: string;
  count: number;
}

export interface ICityChartS {}
export interface ICityChart {
  data: Array<
    IChartBarsMetrics | IMissingCity | IMissingCountry | IMetricsContent
  >;
  chartSyncId?: string;
}

const ChartBars: React.FC<ICityChart> = (props) => {
  const [dataWithColors] = useColorsChartBars(props.data);
  if (!dataWithColors.length) {
    return <p>No Data to Show</p>;
  }
  return (
    <ResponsiveContainer width={"100%"} height={310}>
      <BarChart
        syncId={props.chartSyncId || "cityChart"}
        width={730}
        height={250}
        data={dataWithColors}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="count" fill="#82ca9d" />
        {props.data && props.data.length && (
          <Brush dataKey="name" height={30} stroke="#8884d8" />
        )}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default React.memo(ChartBars);
